import { useReduxState } from 'hooks';
import { EventLog } from 'components/common/events';

const ProfileChangelog = () => {
  const {
    pageState: { user }
  } = useReduxState();

  return !user ? null : (
    <EventLog
      isChangelogEvent={true}
      onlyEventsOfType="changelog"
      targetUserId={user.id}
    />
  );
};

export default ProfileChangelog;
